module.exports = __webpack_public_path__ + "static/media/appointmentimg.6e3c1c05.png";